interface IGetCachedParams {
  cache: Storage;
  label: string;
}

export const getCached = ({ cache, label }: IGetCachedParams) =>
  cache.getItem(label);
